"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _cccisdFormik = require("cccisd-formik");
var _cccisdNotification = _interopRequireDefault(require("cccisd-notification"));
var _admin = require("../../../selectors/admin.js");
var _index = require("../index.js");
var _PermissionCheckboxInput = _interopRequireDefault(require("./PermissionCheckboxInput.js"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var Boilerplate = window.cccisd && window.cccisd.boilerplate;
var Fortress = window.cccisd && window.cccisd.fortress;
var PermissionForm = function PermissionForm(_ref) {
  var closeModal = _ref.closeModal,
    initialValues = _ref.initialValues,
    loadData = _ref.loadData,
    pawnIds = _ref.pawnIds;
  var project = (0, _reactRedux.useSelector)(function (state) {
    return (0, _admin.getCurrentProject)(state.assignment.admin);
  }) || {};

  /* /////////////////////////////////////////////////////////////////////////
  // FORMIK FUNCTIONS ///////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////// */
  function onSubmit(_x) {
    return _onSubmit.apply(this, arguments);
  }
  /* /////////////////////////////////////////////////////////////////////////
  // RENDER /////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////// */
  function _onSubmit() {
    _onSubmit = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(values) {
      var response;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _context.n = 1;
            return _cccisdAxios["default"].post(Boilerplate.route('api.assignment.questpermission.bulkPawns', {
              projectId: project.groupId
            }), {
              pawnIds: pawnIds,
              permissions: values
            });
          case 1:
            response = _context.v;
            if (!response.data) {
              _context.n = 3;
              break;
            }
            if (!(response.data.status === 'success')) {
              _context.n = 2;
              break;
            }
            loadData();
            closeModal();
            if (pawnIds.includes(Fortress.user.acting.id)) {
              window.location.reload();
            }
            return _context.a(2);
          case 2:
            (0, _cccisdNotification["default"])({
              type: 'danger',
              message: 'Failed to change permissions',
              duration: 5000
            });
            return _context.a(2, Promise.reject(response.data.errors));
          case 3:
            (0, _cccisdNotification["default"])({
              type: 'danger',
              message: 'Failed to change permissions',
              duration: 5000
            });
          case 4:
            return _context.a(2);
        }
      }, _callee);
    }));
    return _onSubmit.apply(this, arguments);
  }
  var permissionFormFields = Object.keys(initialValues).map(function (key) {
    var pData = _index.permissionsData.find(function (p) {
      return p.permission === key;
    });
    var header;
    var label = key;
    if (pData) {
      var LabelIcon = pData.labelIcon;
      label = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].iconSpace
      }, /*#__PURE__*/_react["default"].createElement(LabelIcon, null)), pData.formLabel || pData.tooltip);
      header = pData.topHeader ? /*#__PURE__*/_react["default"].createElement("h4", null, pData.topHeader) : null;
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: key
    }, header, /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].checkboxIndent
    }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "['".concat(key, "']"),
      component: _PermissionCheckboxInput["default"],
      label: label,
      labelNotBold: true
    })));
  });
  return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Formik, {
    initialValues: initialValues,
    onSubmit: onSubmit
  }, function (_ref2) {
    var isSubmitting = _ref2.isSubmitting;
    return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Form, null, permissionFormFields, /*#__PURE__*/_react["default"].createElement("button", {
      className: "btn btn-primary",
      type: "submit",
      disabled: isSubmitting || !pawnIds.length
    }, "Submit"));
  });
};
PermissionForm.propTypes = {
  closeModal: _propTypes["default"].func,
  initialValues: _propTypes["default"].object.isRequired,
  loadData: _propTypes["default"].func,
  pawnIds: _propTypes["default"].array.isRequired,
  projectId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
};
var _default = exports["default"] = PermissionForm;